var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 94.879 94.879",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.141,33.189c3.3-3.4,6.3-6.9,9.4-10.4l0.5-0.3l0,0c0.9-0.6,1.2-1.7,0.7-2.7l-0.7-1.1c-4.4-7.2-11.1-12.3-16.7-18.5 c-0.3-0.3-1.2-0.2-1.6,0c-0.9,0.4-1.2,1.3-1.1,2.3c0.3,3.1,1.7,5.7,3.6,8c2.1,2.5,4.3,5.1,6.5,7.6c-0.1,0-0.3,0-0.4-0.1 c-4.7-0.3-9.4-0.7-14.1-0.7c-7.5,0.1-15.1,0.5-22.6,0.7c-13.5-2.2-27.3-1-41-1.4c-0.6,0-1.6,0.7-1.9,1.1c-0.6,1,0.2,1.8,1.3,2.4 c3.8,2,8.5,2.9,13.2,3.1c11.3,0.6,22.7,1.4,34.1,0.8c1.4,0.1,2.8,0.2,4.2,0.2c8.6,0.3,17.2,0.4,25.8-0.3 c-3.7,3.3-7.1,6.8-10.1,10.8c-1,1.3-1.2,2.8,0.1,4c1.2,1.1,2.9,1.1,4.1,0.1C78.741,36.989,81.141,35.189,83.141,33.189z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.441,60.289c1-1.3,1.2-2.9-0.2-4.1c-1.2-1-2.9-0.9-4.1,0c-2.3,1.8-4.6,3.6-6.6,5.6c-3.3,3.4-6.3,6.9-9.4,10.4l0,0l0,0 c-1.2,0.7-1.6,2.3-0.9,3.4l0.4,0.6c4.4,7.2,11.1,12.3,16.7,18.5c0.3,0.3,1.2,0.2,1.6,0c0.9-0.4,1.2-1.3,1.1-2.3 c-0.3-3.1-1.7-5.7-3.6-8c-2.2-2.5-4.3-5.1-6.5-7.6c0.1,0,0.3,0,0.4,0.1c4.7,0.3,9.4,0.7,14.1,0.7c7.5-0.1,15.1-0.5,22.6-0.7 c13.5,2.2,27.3,1,41,1.4c0.6,0,1.6-0.7,1.9-1.1c0.6-1-0.2-1.8-1.3-2.4c-3.8-2-8.5-2.9-13.2-3.1c-11.3-0.6-22.7-1.4-34.1-0.8 c-1.4-0.1-2.8-0.2-4.2-0.2c-8.6-0.3-17.2-0.4-25.8,0.3C15.941,67.689,19.441,64.289,22.441,60.289z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.29b5a7520975f0486777598dd4de684e.svg";
export { ForwardRef as ReactComponent };